import { baseApi } from '../../../core/baseApi';
import { unwrapApiResponse } from '../../../patterns/crud';

export const reviewRequestApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getReviewRequestStats: builder.query<
      { monthlyCount: number },
      void
    >({
      query: () => ({ url: '/review-request/stats' }),
      transformResponse: unwrapApiResponse<{ monthlyCount: number }>,
      providesTags: [{ type: 'ReviewRequestStats', id: 'CURRENT_MONTH' }],
    }),

    getReviewRequestContactStatus: builder.query<
      { lastSentAt: string | null },
      { conversationId: string }
    >({
      query: ({ conversationId }) => ({
        url: `/review-request/${conversationId}/contact-status`,
      }),
      transformResponse: unwrapApiResponse<{ lastSentAt: string | null }>,
    }),
  }),
});

export const {
  useGetReviewRequestStatsQuery,
  useLazyGetReviewRequestContactStatusQuery,
} = reviewRequestApi;
